export interface AppConfigColors {
    primary?: string;
    secondary?: string;
    tertiary?: string;
}

function normalizeColorToken(value: string): string {
    return value.trim().toLowerCase().replace(/\s+/g, ' ');
}

function normalizeHex(value: string): string | undefined {
    const trimmed = value.trim();
    if (!trimmed) return undefined;

    const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
    const cleaned = withHash.replace('#', '');
    if (cleaned.length === 3 || cleaned.length === 6) {
        return withHash;
    }
    return undefined;
}

/**
 * Resolves a user-facing background selection (e.g. "Primary Colour") to a real hex value.
 *
 * Supports:
 * - Literal hex strings (e.g. `#ffffff`, `fff`)
 * - Tokens/labels mapping to `colors.primary` / `colors.secondary`
 */
export function resolveBrandBackgroundHex(
    selection: string | undefined,
    colors: AppConfigColors | undefined,
): string | undefined {
    if (!selection) return undefined;

    // If it already looks like a hex value, use it.
    const directHex = normalizeHex(selection);
    if (directHex) return directHex;

    const token = normalizeColorToken(selection);
    switch (token) {
        case 'primary':
        case 'primary colour':
        case 'primary color':
            return colors?.primary;
        case 'secondary':
        case 'secondary colour':
        case 'secondary color':
            return colors?.secondary;
        case 'tertiary':
        case 'tertiary colour':
        case 'tertiary color':
            return colors?.tertiary;
        default:
            return undefined;
    }
}
